import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { RoleRoute } from '@/router/RoleRoute';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const CartPage = lazy(() => import('./pages/CartPage').then((m) => ({ default: m.CartPage })));
const OrderConfirmedPage = lazy(() =>
  import('./pages/OrderConfirmedPage').then((m) => ({ default: m.OrderConfirmedPage })),
);
const OrdersPage = lazy(() => import('./pages/OrdersPage').then((m) => ({ default: m.OrdersPage })));
const OrderDetailPage = lazy(() => import('./pages/OrderDetailPage').then((m) => ({ default: m.OrderDetailPage })));
const PlannedOrderPage = lazy(() =>
  import('./pages/PlannedOrderPage').then((m) => ({ default: m.PlannedOrderPage })),
);
const DebtPage = lazy(() => import('./pages/DebtPage').then((m) => ({ default: m.DebtPage })));
const CourierProfilePage = lazy(() =>
  import('./pages/CourierProfilePage').then((m) => ({ default: m.CourierProfilePage })),
);
const RateCourierPage = lazy(() => import('./pages/RateCourierPage').then((m) => ({ default: m.RateCourierPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const FavoritesPage = lazy(() => import('./pages/FavoritesPage').then((m) => ({ default: m.FavoritesPage })));
const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

function client(element: ReactElement): ReactElement {
  return (
    <ProtectedRoute>
      <RoleRoute roles={['CLIENT']}>
        <Suspense fallback={<RouteFallback />}>{element}</Suspense>
      </RoleRoute>
    </ProtectedRoute>
  );
}

/**
 * F1 — Klient ekranlari (K-01…K-12). CLAUDE.md §6 — registry.ts tomonidan
 * avtomatik yig'iladi. Yo'llar `lib/navConfig.ts` dagi NAV_CONFIG.CLIENT bilan mos.
 */
export const routes: RouteObject[] = [
  { path: '/client', element: client(<HomePage />) },
  { path: '/client/cart', element: client(<CartPage />) },
  { path: '/client/order-confirmed', element: client(<OrderConfirmedPage />) },
  { path: '/client/orders', element: client(<OrdersPage />) },
  { path: '/client/orders/:id', element: client(<OrderDetailPage />) },
  { path: '/client/planned-order', element: client(<PlannedOrderPage />) },
  { path: '/client/debt', element: client(<DebtPage />) },
  { path: '/client/couriers/:id', element: client(<CourierProfilePage />) },
  { path: '/client/couriers/:id/rate', element: client(<RateCourierPage />) },
  { path: '/client/profile', element: client(<ProfilePage />) },
  { path: '/client/favorites', element: client(<FavoritesPage />) },
  { path: '/client/notifications', element: client(<NotificationsPage />) },
];
